import React from 'react';
import { motion } from 'framer-motion';
interface ViewToggleProps {
  currentView: 'front' | 'back';
  onViewChange: (view: 'front' | 'back') => void;
  showBackView: boolean;
}
export function ViewToggle({
  currentView,
  onViewChange,
  showBackView
}: ViewToggleProps) {
  if (!showBackView) return null;
  return <div className="flex items-center justify-center gap-2 mb-6" data-id="element-111">
      <div className="relative bg-white rounded-lg p-1 shadow-sm border border-gray-200" data-id="element-112">
        <div className="flex gap-1" data-id="element-113">
          <button onClick={() => onViewChange('front')} className={`
              relative px-6 py-2 rounded-md text-sm font-medium transition-colors z-10
              ${currentView === 'front' ? 'text-white' : 'text-gray-600 hover:text-gray-900'}
            `} data-id="element-114">
            Front
          </button>
          <button onClick={() => onViewChange('back')} className={`
              relative px-6 py-2 rounded-md text-sm font-medium transition-colors z-10
              ${currentView === 'back' ? 'text-white' : 'text-gray-600 hover:text-gray-900'}
            `} data-id="element-115">
            Back
          </button>
        </div>

        <motion.div className="absolute top-1 bottom-1 bg-black rounded-md" initial={false} animate={{
        left: currentView === 'front' ? '4px' : '50%',
        right: currentView === 'front' ? '50%' : '4px'
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 30
      }} data-id="element-116" />
      </div>
    </div>;
}